
import CreateWinery from './CreateWinery';
import React from 'react';
import { useDispatch } from 'react-redux';
import { createWinery } from "../../../actions/wineryActions";

export const CreateWineryContainer = () => {
    const dispatch = useDispatch();
    return (
        <div>
            <CreateWinery setdata = {(values) => dispatch(createWinery(values))} />
        </div>
    )
}